import getOrderBumpOffers, {
  isOfferCompatibleWithSelectedPrice,
  resolveCompatSelectedPrice,
} from './getOrderBumpOffers';
import getOrderBumpValues from './getOrderBumpValues';
import hasStock from './hasStock';

/**
 * The bumps the buyer is taking, as `{ offer, quantity, payWhatYouWantAmount }`
 * in the order the submission serializes them (getOrderBumpValues).
 *
 * Only offers the storefront shows (compatible with the selected price, in
 * stock) count, so the cart and the pre-payment checks agree: a lingering form
 * entry for a hidden offer must neither move the totals nor block the checkout.
 */
export default function getSelectedOrderBumps({ page, product, selectedPrice, form, currency }) {
  const compatSelectedPrice = resolveCompatSelectedPrice(product, selectedPrice);
  const offerById = new Map(
    getOrderBumpOffers(page, product, page?.orderBumpProducts).map(offer => [
      String(offer.productId),
      offer,
    ]),
  );

  return getOrderBumpValues(form?.orderBumps, form?.orderBumpAmounts, currency)
    .map(({ productId, quantity, payWhatYouWantAmount }) => ({
      offer: offerById.get(productId),
      quantity,
      payWhatYouWantAmount,
    }))
    .filter(
      ({ offer }) =>
        offer != null &&
        isOfferCompatibleWithSelectedPrice(offer, compatSelectedPrice) &&
        hasStock(offer.product),
    );
}
